import axios from "axios";

export const filemanagerApi = axios.create({
  baseURL: process.env.VUE_APP_FILEMANAGER_API,
  headers: {
    "Content-type": "application/json",
  },
});
